import { IComponentOptions, IController } from 'angular';
import { CartService } from '../../../../tn.cart/service.tn.cart';
import { LocalFavorites } from '../../../../tn.favorites/local-favorites.service/localFavorites';
import { IFontStyleModel } from '../../../classes';
import { FontWidth } from '../../../constants';
import { FontGroup } from '../family-specimen/family-specimen';
import template from './specimens-group.html';

export class ISpecimensGroupComponentBindings {
    group?: FontGroup<FontWidth>;
    scale = 100;
    collapsed = false;
    customText?: string;
    onBuyStyleClicked?: ({ $event, style }) => void;
    onSaveStyleClicked?: ({ $event, style }) => void;
}

export class SpecimensGroupComponent
    extends ISpecimensGroupComponentBindings
    implements IController
{
    static $inject = ['tn.cart.service', 'localFavorites'];
    constructor(
        protected cartService: CartService,
        protected localFavorites: LocalFavorites
    ) {
        super();
    }

    buyStyle($event: Event, style: IFontStyleModel): void {
        $event.preventDefault();
        this.onBuyStyleClicked &&
            this.onBuyStyleClicked({
                $event,
                style,
            });
    }

    saveStyle($event: Event, style: IFontStyleModel): void {
        $event.preventDefault();
        this.onSaveStyleClicked &&
            this.onSaveStyleClicked({
                $event,
                style,
            });
    }

    isFavorite(font: IFontStyleModel): boolean {
        return this.localFavorites.isFavoriteStyle(font.id);
    }
}

export const SpecimensGroupComponentOptions: IComponentOptions = {
    controller: SpecimensGroupComponent,
    bindings: {
        group: '<',
        scale: '<',
        collapsed: '<',
        onBuyStyleClicked: '&',
        onSaveStyleClicked: '&',
        customText: '<?',
    },
    template,
};
